// extracted by mini-css-extract-plugin
module.exports = {"CommentListPlaceholder":"iv_a bhh_je","CommentListPlaceholder--Legacy":"iv_b bhh_qh bhh_vk"};